// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Header_navbar__LmPAV","bgWhite":"Header_bgWhite__GfykR","hidden":"Header_hidden__pM4KD"};